import {CATALOGUE_SYNC_API} from '@repo/shared/api/catalogue_index';
import {Arr, Bool, Num, Obj, Opt, OptNum, OptStr, Str} from '@repo/shared/api/core/api_schema';
import type {SchemaToType} from '@repo/shared/api/core/api_schema';
import {MOVIE_IDENTIFICATION_API} from '@repo/shared/api/movie_identification';
import {NzbMediaMetadataSchema} from '@repo/shared/api/nzb_media_metadata';
import {TvPreferencesSchema} from '@repo/shared/api/tv_preferences';

export const TvMovieSchema = Obj({
  imdbId: Str(),
  title: Str(),
  overview: Str(),
  posterPath: OptStr(),
  year: OptStr(),
  runtimeMinutes: OptNum(),
  rating: OptNum(),
});
export type TvMovie = SchemaToType<typeof TvMovieSchema>;
export const TvReleaseSchema = Obj({
  id: Str(),
  title: Str(),
  bytes: Num(),
  publishedAt: Num(),
  cached: Bool(),
  health: Str<'healthy' | 'unhealthy' | 'unknown'>(),
  checkedAt: OptNum(),
  mediaMetadata: Opt(NzbMediaMetadataSchema),
});
export type TvRelease = SchemaToType<typeof TvReleaseSchema>;
const TvReleaseOptionSchema = Obj({
  id: Str(),
  title: Str(),
  bytes: Num(),
  cached: Bool(),
  trackStatus: OptStr<'complete' | 'error' | 'skipped' | 'suspicious'>(),
  trackError: Bool(),
  audioLanguages: Arr(Str()),
  subtitleLanguages: Arr(Str()),
});
export type TvReleaseOption = SchemaToType<typeof TvReleaseOptionSchema>;
const TvMovieAvailabilitySchema = Obj({
  imdbId: Str(),
  availability: Str<'matching' | 'available' | 'unavailable'>(),
});
export type TvMovieAvailability = SchemaToType<typeof TvMovieAvailabilitySchema>;
export const TV_CATALOGUE_API = {
  ...CATALOGUE_SYNC_API,
  ...MOVIE_IDENTIFICATION_API,
  '/catalogue/movies': {
    POST: {req: Obj({cursor: OptStr()}), res: Obj({movies: Arr(TvMovieSchema), cursor: OptStr()})},
  },
  '/catalogue/library': {
    POST: {req: Obj({imdbIds: Arr(Str())}), res: Obj({movies: Arr(TvMovieSchema)})},
  },
  '/catalogue/releases': {
    POST: {
      req: Obj({imdbId: Str(), cursor: OptStr()}),
      res: Obj({releases: Arr(TvReleaseSchema), cursor: OptStr()}),
    },
  },
  '/catalogue/release-options': {
    POST: {
      req: Obj({imdbId: Str()}),
      res: Obj({releases: Arr(TvReleaseOptionSchema)}),
    },
  },
  '/catalogue/availability': {
    POST: {
      req: Obj({imdbIds: Arr(Str()), preferences: TvPreferencesSchema}),
      res: Obj({movies: Arr(TvMovieAvailabilitySchema)}),
    },
  },
  '/catalogue/nzb': {
    POST: {
      req: Obj({imdbId: Str(), releaseId: Str()}),
      res: Obj({releaseId: Str(), url: Str(), fileName: Str(), expiresAt: Num()}),
    },
  },
};
